import { render, staticRenderFns } from "./SettingsAdvertiser.vue?vue&type=template&id=5053996e&scoped=true&"
import script from "./SettingsAdvertiser.vue?vue&type=script&lang=js&"
export * from "./SettingsAdvertiser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053996e",
  null
  
)

export default component.exports